module.exports = __webpack_public_path__ + "files/ccd061a2f5df738e0b7fc513dcbb9dd9.png";